export class CreateFabricTableShortcutDemoResponseResultsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "success",
            "baseName": "success",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFabricTableShortcutDemoResponseResultsInner.attributeTypeMap;
    }
    constructor() {
    }
}
